document.addEventListener("DOMContentLoaded", async () => {
    // Key Visual Video
    const videoBgEl = document.querySelectorAll(".handle-bg__video");
    if (videoBgEl.length > 0) {
        const { initVideo, setupVideoFade } = await import("../components/video.js");
        initVideo();
        setupVideoFade();
        let timeout;
        window.addEventListener("resize", function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                initVideo();
                setupVideoFade();
            }, 300);
        });
    }

    // Information Top Slider
    const informationEls = document.querySelector(".js-information-keyv");
    if (informationEls) {
        const { renderInformationSlider } = await import(
            "../components/swiper.js"
        );
        renderInformationSlider(informationEls);
    }

    // Thumbnail Top Slider
    const carouselImgEls = document.getElementById("js-slide-thumbnail");
    if (carouselImgEls) {
        const { renderThumbnailKeyvSlider } = await import(
            "../components/swiper.js"
        );
        renderThumbnailKeyvSlider(carouselImgEls);
    }

    // AOS - Animate On Scroll
    const { initAOS } = await import('../components/aos.js');
    initAOS();

    const { disableContextImage } = await import("../components/detect-image.js");
    disableContextImage("#news-list");

    // Scroll Animations
    const ttlElements = document.querySelectorAll(".js-animate-title");
    if (ttlElements.length) {
        const { animateTitle } = await import("../components/scroll.js");
        animateTitle(ttlElements);

        // Collect all .ttl-animate elements inside .js-animate-title
        const animateNodes = Array.from(ttlElements).flatMap((el) =>
            Array.from(el.querySelectorAll(".ttl-animate"))
        );

        // IntersectionObserver callback
        const handleIntersection = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-active");
                    observer.unobserve(entry.target);
                }
            });
        };

        // Create observer
        const observer = new IntersectionObserver(handleIntersection, {
            threshold: 0.2,
        });
        animateNodes.forEach((node) => observer.observe(node));
    }

    // Company Slider
    const companyEls = document.getElementById("slider-company");
    if (companyEls) {
        const { renderCompanySlide } = await import("../components/slider.js");
        renderCompanySlide(companyEls);
    }

    const sliderGraduateEls = document.querySelectorAll(".js-graduate-slider");

    if (sliderGraduateEls.length > 0) {
        const { renderGraduateHome } = await import("../components/slider.js");
        const { PaginationProgress } = await import("../components/pagination-progress.js");

        sliderGraduateEls.forEach((el) => {
            const splide = renderGraduateHome(el);
            if (!splide) return;

            const pagination = new PaginationProgress(
                splide.root.querySelector(".splide__pagination")
            );

            const DURATION = 5000;
            const INTERVAL = 100;
            let timer = null;
            let elapsed = 0;
            let isVisible = false;

            const startProgress = () => {
                if (!isVisible) return;
                pagination.resetAll();

                const activeIndex = splide.index;
                elapsed = 0;
                clearInterval(timer);

                timer = setInterval(() => {
                    if (!isVisible) return;

                    elapsed += INTERVAL;
                    const percent = Math.min((elapsed / DURATION) * 100, 100);
                    pagination.setProgress(activeIndex, percent);

                    if (percent >= 100) {
                        clearInterval(timer);
                        setTimeout(() => {
                            splide.go(">");
                        }, 150);
                    }
                }, INTERVAL);
            };

            const stopProgress = () => {
                clearInterval(timer);
                timer = null;
            };

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            isVisible = true;
                            startProgress();
                        } else {
                            isVisible = false;
                            stopProgress();
                        }
                    });
                },
                { threshold: 0.3 }
            );
            observer.observe(el);

            splide.on("moved", () => {
                clearInterval(timer);
                startProgress();
            });

            window.addEventListener(
                "resize",
                () => {
                    pagination.refresh();
                    clearInterval(timer);
                    startProgress();
                },
                { passive: true }
            );

            splide.on("mounted", () => {
                setTimeout(() => startProgress(), 400);
            });
        });
    }

    // Close popup when click close button
    const { closePopupBanner } = await import("../components/popup.js");
    closePopupBanner();

    // Popup banner suppression (session + cookie based)
    const { initPopupBanner } = await import('../components/popup-banner.js');
    initPopupBanner();

    // News Loader
    const { newsLoader } = await import("../components/news-loader.js");
    newsLoader();
});
